/*!
 * Find Your Bag — PDP Guided Purchase (v2.4)
 * - Rewrites H1 + sticky bar to bag-specific copy
 * - Auto-selects the recommended pillow size
 * - Hides the Size option group so shoppers only pick a color
 * - Injects the Perfect Fit panel above the product info (with “Or choose another size” escape hatch)
 */
(function(){
  'use strict';

  function ready(fn){
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else { fn(); }
  }

  function esc(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function buildPanel(state, altVariants){
    var bagLabel = esc(state.bag_label || 'your bag');
    var pillow = esc(state.pillow || '');
    var alts = altVariants.map(function(v){
      var soldout = v.available ? '' : ' is-soldout';
      var disabled = v.available ? '' : 'disabled';
      var soldoutTxt = v.available ? '' : '<span class="fyb-pf-alt-soldout">Sold out</span>';
      var dims = v.dims ? '<span class="fyb-pf-alt-dims">' + esc(v.dims) + '</span>' : '';
      return '<label class="fyb-pf-alt-option' + soldout + '">' +
        '<input type="radio" name="fyb-alt-size" value="' + esc(v.id) + '" ' +
          'data-variant-id="' + esc(v.id) + '" ' +
          'data-size-label="' + esc(v.size) + '" ' + disabled + '>' +
        '<span class="fyb-pf-alt-swatch"></span>' +
        '<span class="fyb-pf-alt-text">' +
          '<span class="fyb-pf-alt-size">' + esc(v.size) + '</span>' +
          dims + soldoutTxt +
        '</span>' +
      '</label>';
    }).join('');

    return '<div class="fyb-perfect-fit" data-fyb-panel aria-live="polite">' +
      '<div class="fyb-pf-inner">' +
        '<div class="fyb-pf-header">' +
          '<span class="fyb-pf-eyebrow">Perfect Fit Found</span>' +
          '<h2 class="fyb-pf-title">' +
            '<span class="fyb-pf-title-static">For your</span> ' +
            '<span class="fyb-pf-bag" data-fyb-bag-label>' + bagLabel + '</span>' +
          '</h2>' +
        '</div>' +
        '<div class="fyb-pf-body">' +
          '<div class="fyb-pf-recommendation">' +
            '<div class="fyb-pf-rec-row">' +
              '<span class="fyb-pf-rec-label">Recommended pillow</span>' +
              '<span class="fyb-pf-rec-value" data-fyb-pillow>' + pillow + '</span>' +
            '</div>' +
          '</div>' +
          '<p class="fyb-pf-note">Size and quantity are set based on your bag. Choose your color below.</p>' +
          '<div class="fyb-pf-actions">' +
            '<button type="button" class="fyb-pf-view-all" data-fyb-view-all aria-expanded="false" aria-controls="fyb-pf-alt-sizes">Or choose another size</button>' +
            '<a href="/pages/compatibility" class="fyb-pf-change-bag" data-fyb-change-bag>Change bag</a>' +
          '</div>' +
          '<div class="fyb-pf-alt-sizes" id="fyb-pf-alt-sizes" data-fyb-alt-sizes hidden>' +
            '<span class="fyb-pf-alt-label">Available sizes</span>' +
            '<div class="fyb-pf-alt-options" data-fyb-alt-options role="radiogroup" aria-label="Pillow size">' +
              alts +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function collectAltVariants(){
    var buttons = document.querySelectorAll('.fab-option-group[data-option-name="Size"] .fab-pill');
    var out = [];
    buttons.forEach(function(btn){
      var size = (btn.getAttribute('data-value') || btn.textContent || '').trim();
      size = size.split('\n')[0].trim();
      var available = btn.getAttribute('data-disabled') !== 'true';
      out.push({ id: size, size: size, url: '', available: available, dims: '' });
    });
    return out;
  }

  function findRecommendedSizeButton(pillow){
    var sizeGroup = document.querySelector('.fab-option-group[data-option-name="Size"]');
    if (!sizeGroup) return null;
    var buttons = sizeGroup.querySelectorAll('.fab-pill[data-value]');
    var normalizedPillow = pillow.trim().toLowerCase();
    for (var i = 0; i < buttons.length; i++){
      var btn = buttons[i];
      var label = (btn.getAttribute('data-value') || '').trim().toLowerCase();
      if (label === normalizedPillow ||
          label.indexOf(normalizedPillow + ' ') === 0 ||
          label.indexOf(normalizedPillow + '(') === 0 ||
          label.split(' ')[0] === normalizedPillow) {
        return btn;
      }
    }
    return null;
  }

  function hideSizeGroup(){
    var sizeGroup = document.querySelector('.fab-option-group[data-option-name="Size"]');
    if (sizeGroup) sizeGroup.setAttribute('data-fyb-hidden','true');
    // Also hide any size-guide link that lives outside the option group
    var sizeGuideLink = document.querySelector('[data-fab-size-guide-toggle]');
    if (sizeGuideLink) sizeGuideLink.setAttribute('data-fyb-hidden','true');
    var sizeGuidePanel = document.querySelector('[data-fab-size-guide-panel]');
    if (sizeGuidePanel) sizeGuidePanel.setAttribute('data-fyb-hidden','true');
  }

  function showSizeGroup(){
    var sizeGroup = document.querySelector('.fab-option-group[data-option-name="Size"]');
    if (sizeGroup) sizeGroup.removeAttribute('data-fyb-hidden');
    var sizeGuideLink = document.querySelector('[data-fab-size-guide-toggle]');
    if (sizeGuideLink) sizeGuideLink.removeAttribute('data-fyb-hidden');
  }

  // Inject a tiny stylesheet so [data-fyb-hidden] really hides the group
  function injectHiddenStyle(){
    if (document.getElementById('fyb-hidden-style')) return;
    var s = document.createElement('style');
    s.id = 'fyb-hidden-style';
    s.textContent = '[data-fyb-hidden="true"]{display:none !important;}';
    document.head.appendChild(s);
  }

  ready(function(){
    var state = window.FYB;
    if (!state || !state.active) return;

    injectHiddenStyle();

    var oldBanner = document.getElementById('fab-bag-banner');
    if (oldBanner) oldBanner.style.display = 'none';

    // Rewrite H1 + sticky ATC bar titles to bag-specific copy
    if (state.bag_label) {
      var bespokeTitle = 'Purse Pillow for ' + state.bag_label;
      function rewriteTitles(){
        var h1 = document.querySelector('.fab-info .fab-title');
        if (h1 && h1.textContent.trim() !== bespokeTitle) h1.textContent = bespokeTitle;
        var dsName = document.querySelector('.fab-desktop-sticky .fab-ds-name');
        if (dsName && dsName.textContent.trim() !== bespokeTitle) dsName.textContent = bespokeTitle;
        var mobileTitle = document.querySelector('.fab-sticky-bar .fab-sticky-title');
        if (mobileTitle && mobileTitle.textContent.trim() !== bespokeTitle) mobileTitle.textContent = bespokeTitle;
      }
      rewriteTitles();
      var titleObserver = new MutationObserver(rewriteTitles);
      var infoEl = document.querySelector('.fab-info');
      var dsBar = document.querySelector('.fab-desktop-sticky');
      var mobBar = document.querySelector('.fab-sticky-bar');
      if (infoEl) titleObserver.observe(infoEl, {childList: true, subtree: true, characterData: true});
      if (dsBar) titleObserver.observe(dsBar, {childList: true, subtree: true, characterData: true});
      if (mobBar) titleObserver.observe(mobBar, {childList: true, subtree: true, characterData: true});
    }

    // Auto-select the recommended pillow size, then hide the picker.
    if (state.pillow) {
      var attempts = 0;
      function trySelect(){
        attempts++;
        var btn = findRecommendedSizeButton(state.pillow);
        if (!btn) {
          if (attempts < 15) setTimeout(trySelect, 100);
          else hideSizeGroup(); // still hide even if we couldn't match
          return;
        }
        if (btn.classList.contains('is-active')) {
          hideSizeGroup();
          return;
        }
        try { btn.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window})); } catch(e){ try { btn.click(); } catch(e2){} }
        setTimeout(function(){
          var active = document.querySelector('.fab-option-group[data-option-name="Size"] .fab-pill.is-active');
          if (active && active === btn) {
            hideSizeGroup();
          } else if (attempts < 15) {
            setTimeout(trySelect, 100);
          } else {
            hideSizeGroup();
          }
        }, 60);
      }
      trySelect();
    } else {
      // No pillow recommendation — still hide the size picker to keep the guided feel
      hideSizeGroup();
    }

    // Inject Perfect Fit panel
    var infoPanel = document.querySelector('.fab-info');
    var host = infoPanel || document.querySelector('main');
    if (!host) return;
    if (host.querySelector('[data-fyb-panel]')) return;

    var altVariants = collectAltVariants();
    var wrapper = document.createElement('div');
    wrapper.innerHTML = buildPanel(state, altVariants);
    var panel = wrapper.firstChild;
    host.insertBefore(panel, host.firstChild);

    var bagEl = panel.querySelector('[data-fyb-bag-label]');
    if (bagEl && state.bag_label) bagEl.textContent = state.bag_label;
    var pillowEl = panel.querySelector('[data-fyb-pillow]');
    if (pillowEl && state.pillow) pillowEl.textContent = state.pillow;

    var viewAllBtn = panel.querySelector('[data-fyb-view-all]');
    var altSizesBox = panel.querySelector('[data-fyb-alt-sizes]');
    if (viewAllBtn && altSizesBox) {
      viewAllBtn.addEventListener('click', function(){
        var isOpen = !altSizesBox.hidden;
        altSizesBox.hidden = isOpen;
        viewAllBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        viewAllBtn.textContent = isOpen ? 'Or choose another size' : 'Use recommended size';
      });

      var radios = altSizesBox.querySelectorAll('input[name="fyb-alt-size"]');
      radios.forEach(function(radio){
        radio.addEventListener('change', function(){
          if (!radio.checked || radio.disabled) return;
          var newSizeLabel = radio.getAttribute('data-size-label') || '';
          var target = findRecommendedSizeButton(newSizeLabel);
          if (!target) return;
          try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({event:'find_your_bag_size_override',fyb_bag:state.bag,fyb_pillow_original:state.pillow,fyb_pillow_chosen:newSizeLabel}); } catch(e){}
          try { target.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window})); } catch(e){ try { target.click(); } catch(e2){} }
          // User picked an override — reveal the picker so they can see what's selected
          showSizeGroup();
        });
      });
    }

    var changeBagLink = panel.querySelector('[data-fyb-change-bag]');
    if (changeBagLink) {
      changeBagLink.addEventListener('click', function(){
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({event:'find_your_bag_change_bag',fyb_bag:state.bag}); } catch(e){}
      });
    }

    function addHiddenInput(form, name, value){
      if (!form || !value) return;
      if (form.querySelector('input[name="properties['+name+']"]')) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties['+name+']';
      input.value = value;
      form.appendChild(input);
    }

    function stampForms(){
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      forms.forEach(function(form){
        if (state.bag_label) addHiddenInput(form, 'Bag', state.bag_label);
        if (state.pillow) addHiddenInput(form, 'Recommended Fit', state.pillow);
        addHiddenInput(form, '_fyb_source', 'find_your_bag');
      });
    }
    stampForms();
    document.addEventListener('variant:change', stampForms);
    document.addEventListener('product:variant-change', stampForms);

    document.addEventListener('submit', function(e){
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      var payload = {event:'find_your_bag_add_to_cart',fyb_bag:state.bag,fyb_brand:state.brand,fyb_bag_label:state.bag_label,fyb_pillow:state.pillow};
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(payload); } catch(e){}
      try { if (window.gtag) window.gtag('event','find_your_bag_add_to_cart', payload); } catch(e){}
    }, true);
  });
})();
